function biggerThanDirective() {

	var link = function($scope, $element, $attrs, ctrl) {

		var validate = function(viewValue) {
			var comparisonModel = $attrs.biggerThan;

			if (!viewValue || !comparisonModel) {
				ctrl.$setValidity('biggerThan', true);
			}

			ctrl.$setValidity('biggerThan', parseFloat(viewValue) > parseFloat(comparisonModel));
			return viewValue;
		};

		ctrl.$parsers.unshift(validate);
		ctrl.$formatters.push(validate);

		$attrs.$observe('biggerThan', function(comparisonModel) {
			return validate(ctrl.$viewValue);
		});

	};

	return {
		require : 'ngModel',
		link : link
	};

};

module.directive('biggerThan', [ biggerThanDirective ]);